"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const fp = require("fp-ts");
const sok_types_1 = require("@caddigital/sok-types");
const _ActionTypes = require("./actionTypes");
const _Actions = require("./actions");
const userValidation_1 = require("../../utils/userValidation");
const validation_1 = require("../../utils/validation");
const errorHandling_1 = require("../../utils/errorHandling");
function default_1(namespace, opts) {
    const ActionTypes = _ActionTypes.default(namespace);
    const actions = _Actions.default(namespace);
    function validateExternalUser(user) {
        let validation = fp.validation.success(true);
        validation = (0, validation_1.ap)((0, validation_1.hasInvalidLength)('company', null, 150)(user.company))(validation);
        validation = (0, validation_1.ap)((0, userValidation_1.validateUserInformation)(user, opts))(validation);
        validation = (0, validation_1.ap)((0, validation_1.isNotEmpty)('company')(user))(validation);
        return validation;
    }
    function create(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_NEW_REQUEST), (0, operators_1.mergeMap)((request) => validateExternalUser(request.payload.data).fold((e) => (0, rxjs_1.of)(actions.validateFailure(e)), (_) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: request.payload.data,
            url: `${baseUrl}api/addressbook/folder/${request.payload.folder.id}`
        }).pipe((0, operators_1.mergeMap)(({ response }) => sok_types_1.User.iUser.decode(response).fold((e) => (0, rxjs_1.of)(actions.createFailed((0, errorHandling_1.parseValidationError)(e))), (user) => (0, rxjs_1.merge)((0, rxjs_1.of)(actions.createSuccess(request.payload.folder, user)), (0, rxjs_1.of)(actions.clearState())))), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(actions.createFailed((0, errorHandling_1.parseAjaxErrorResponse)(e))))))));
    }
    return { ActionTypes, create };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map